module.exports = {"150925103":"岱海镇","150925104":"六苏木镇","150925105":"麦胡图镇","150925106":"永兴镇","150925107":"蛮汉镇","150925218":"天成乡","150925219":"曹碾满族乡","150925220":"厂汉营乡","150925400":"岱海循环工业发展区","150925401":"蛮汉山林场","150925402":"岱海林场","150925403":"岱海旅游区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150925.json
// module id = 425
// module chunks = 0